import { render } from "./Card.vue?vue&type=template&id=0ed3fd30&scoped=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"

import "./Card.vue?vue&type=style&index=0&id=0ed3fd30&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ed3fd30"

export default script